import React from 'react';
import Card from 'components/fullWidthCard';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import {countries} from 'helpers/constants';
import {optimizerPlusTitle} from 'helpers/dataHelpers';

class Landing extends React.Component {
  static propTypes = {
    dealer: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
  };

  goToPage = page => {
    location.href = page;
  };

  render() {
    const {formatMessage} = this.props.intl;

    return <div className='container quick-calcs-landing'>
      <Card title={formatMessage({id: 'quick-calcs.seasons-usage.title'})}
            link='#tools/quick-calcs/seasons-usage'
            onTitleClick={this.goToPage}
            right={<a className='btn btn-primary pull-right'
                      href='#tools/quick-calcs/seasons-usage'><FormattedMessage id='quick-calcs.landing.cta'/></a>}
            body={<FormattedMessage id='quick-calcs.seasons-usage.overview'/>}/>

      {this.props.dealer.country === countries.US ?
        <Card title={formatMessage({id: 'quick-calcs.system-conversion.title'})}
              link='#tools/quick-calcs/system-conversion'
              onTitleClick={this.goToPage}
              right={<a className='btn btn-primary pull-right'
                        href='#tools/quick-calcs/system-conversion'><FormattedMessage id='quick-calcs.landing.cta'/></a>}
              body={<FormattedMessage id='quick-calcs.system-conversion.overview'/>}/> :
        null}

      <Card title={formatMessage({id: 'quick-calcs.pool-volume.title'})}
            link='#tools/quick-calcs/pool-volume'
            onTitleClick={this.goToPage}
            right={<a className='btn btn-primary pull-right'
                      href='#tools/quick-calcs/pool-volume'><FormattedMessage id='quick-calcs.landing.cta'/></a>}
            body={<FormattedMessage id='quick-calcs.pool-volume.overview'/>}/>

      <Card title={formatMessage({id: this.props.dealer.country === countries.CA ? 'quick-calcs.optimizer-plus.title.ca' : 'quick-calcs.optimizer-plus.title.us'})}
            link='#tools/quick-calcs/optimizer-plus'
            onTitleClick={this.goToPage}
            right={<a className='btn btn-primary pull-right'
                      href='#tools/quick-calcs/optimizer-plus'><FormattedMessage id='quick-calcs.landing.cta'/></a>}
            body={
              <FormattedMessage id={this.props.dealer.country === 'CA' ?
                'quick-calcs.optimizer-plus.overview.ca' :
                'quick-calcs.optimizer-plus.overview.us'}/>} />
    </div>;
  }
}

export default injectIntl(Landing);
